import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "sp-heading"
    }}>{`sp-heading`}</h1>
    <p><strong parentName="p">{`Since:`}</strong>{` UXP v4.1`}</p>
    <p>{`Renders heading text that is theme aware.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://spectrum.adobe.com/page/heading"
        }}>{`https://spectrum.adobe.com/page/heading`}</a></li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-heading>This is a heading</sp-heading>
`}</code></pre>
    <h2 {...{
      "id": "sizes"
    }}>{`Sizes`}</h2>
    <p>{`Headings come in several sizes:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-heading size="XXXL">Heading XXXL</sp-heading>
<sp-heading size="XXL">Heading XXL</sp-heading>
<sp-heading size="XL">Heading XL</sp-heading>
<sp-heading size="L">Heading L</sp-heading>
<sp-heading size="M">Heading M</sp-heading>
<sp-heading size="S">Heading S</sp-heading>
<sp-heading size="XS">Heading XS</sp-heading>
<sp-heading size="XXS">Heading XXS</sp-heading>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      